import { FeeRuleList } from 'pages/payment_deals/fees';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'offers/fees',
  label: 'Regras de Juros e Multa',
  list: FeeRuleList,
  actions: ['list', 'create', 'delete'],
  parentName: 'payment_deals'
};

export default generateResources(resource);
